import {Controller, useFormContext} from "react-hook-form";
import {SubSettingsFormFieldsType} from "../../types";
import {Input, Space} from "antd";
import {FormFieldError} from "../../../../../../../design-system/form-field";

export function SubSettingsUrlRedirectLinkFormField() {
  const {watch, control} = useFormContext<SubSettingsFormFieldsType>();
  const isUrlRedirect = watch("isUrlRedirect");

  return (
    <div>
      {isUrlRedirect && (
        <Controller
          control={control}
          name="url_redirect"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <Input
                // id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value === null ? undefined : value}
                placeholder="Enter Url"
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    </div>
  );
}
